export enum ClientErrorsType {
    AddAccountAccountError = 'AddAccountAccountError',
    AddAccountAnswerError = 'AddAccountAnswerError',
    RegistrationEmailError = 'RegistrationEmailError',
    RegistrationPhoneError = 'RegistrationPhoneError',
    RegistrationAccountError = 'RegistrationAccountError',
    RegistrationAnswerError = 'RegistrationAnswerError',
}